export const dict = {
	custom: {
		end_hour: {
			truthy: "La hora final no puede ser menor que la hora inicial.",
		},
	},
};
